import { rgba } from 'polished';
import { color } from './colors';
var TRANSITION_DELAY = 450;
export var TRANSITION_TIMING_ARGS = [0.23, 1, 0.32, 1];
var TRANSITION_EASING = "cubic-bezier(".concat(TRANSITION_TIMING_ARGS.join(), ")");
/**
 * This file should contain computed properties (like a value for box-shadow, transition, etc.)
 */

export var property = {
  transition: "".concat(TRANSITION_DELAY, "ms ").concat(TRANSITION_EASING, " 0ms"),
  boxShadow: "".concat(rgba(color.palette.black, 0.3), " 0 1px 5px"),
  transitionDelay: TRANSITION_DELAY,
  transitionDuration: TRANSITION_DELAY,
  transitionEasing: TRANSITION_EASING,
  borderRadius: 3
};